'use client';

import { motion } from 'framer-motion';
import { ArrowRight } from '../../icons/ArrowRight';
import type { RelatedFeaturesSectionData } from '../../types';
import { encodeHttpMediaUrl } from '../../utils/media-url';
import { SectionShell, staggerContainer, staggerItem } from '../section-shared';

export function RelatedFeaturesSection({ section }: { section: RelatedFeaturesSectionData }) {
  return (
    <SectionShell>
      <div className="mb-10 w-full text-center sm:mb-8">
        <h2 className="font-semibold text-[36px] text-white leading-[1.2] sm:text-[28px]">{section.title}</h2>
      </div>
      <motion.div
        className="grid grid-cols-4 gap-8 sm:grid-cols-2 sm:gap-4"
        initial="hidden"
        variants={staggerContainer}
        viewport={{ once: true, margin: '-60px' }}
        whileInView="visible"
      >
        {section.items?.map((item) => (
          <motion.a
            key={item._id}
            className="flex flex-col justify-between overflow-hidden rounded-2xl border border-white/10"
            href={`/tools/${item.slug}`}
            target="_blank"
            variants={staggerItem}
          >
            <div className="relative aspect-[4/3] w-full overflow-hidden">
              {item.featuredImage?.url && (
                <img
                  alt={item.featuredImage.alt || item.title}
                  className="h-full w-full object-cover"
                  src={encodeHttpMediaUrl(item.featuredImage.url)}
                />
              )}
            </div>
            <div className="flex flex-1 items-center gap-2 bg-[#484848] p-4">
              <p className="line-clamp-2 min-w-0 flex-1 font-medium text-[15px] text-white capitalize leading-[1.2]">
                {item.title}
              </p>
              <ArrowRight className="size-8 shrink-0 text-white" />
            </div>
          </motion.a>
        ))}
      </motion.div>
    </SectionShell>
  );
}
